import React from 'react';
import { green, red } from '@mui/material/colors';
import { Box, Chip } from '@mui/material';
import CheckIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const greenColor = green[500];
const redColor = red[400];

const iconSize = '16px';
const icons = {
  true: <CheckIcon style={{ color: greenColor, fontSize: iconSize }} />,
  false: <CancelIcon style={{ color: redColor, fontSize: iconSize }} />
};

// Fonction utilitaire pour normaliser les valeurs booléennes
const normalizeBoolean = (value: boolean | string | null | undefined): boolean => {
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true';
  }
  return Boolean(value);
};

const TrueFalse = ({ value }: { value: boolean | string | null | undefined }) => {
  const boolValue = normalizeBoolean(value);
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>{icons[boolValue ? 'true' : 'false']}</Box>
  );
};

export default TrueFalse;

const TrueFalseChip = ({
  value,
  trueLabel,
  falseLabel,
  small
}: {
  value: boolean | string | null | undefined;
  trueLabel: string;
  falseLabel: string;
  small?: boolean;
}) => {
  const boolValue = normalizeBoolean(value);

  const sx: { [key: string]: any } = {
    fontSize: '0.7rem',
    backgroundColor: boolValue ? greenColor : redColor,
    color: '#fff'
  };
  const iconStyle: { [key: string]: any } = { color: '#fff' };

  if (small) {
    sx['height'] = '18px';
    iconStyle['fontSize'] = '1rem';
  }

  return (
    <Chip
      sx={sx}
      size="small"
      label={boolValue ? trueLabel : falseLabel}
      icon={
        boolValue ? (
          <CheckIcon fontSize="small" style={iconStyle} />
        ) : (
          <CancelIcon fontSize="small" style={iconStyle} />
        )
      }
    />
  );
};

const TranslatedTrueFalseChip = ({
  value,
  fieldName,
  small
}: {
  value: boolean | string | null | undefined;
  fieldName: string;
  small?: boolean;
}) => {
  const booleansLabels = {
    is_active: { true: 'Actif', false: 'Inactif' },
    is_active_fem: { true: 'Activée', false: 'Désactivée' },
    default: { true: 'Oui', false: 'Non' }
  };

  const target = booleansLabels[fieldName as keyof typeof booleansLabels] || booleansLabels.default;

  return (
    <TrueFalseChip small={small} value={value} trueLabel={target.true} falseLabel={target.false} />
  );
};

export { TrueFalseChip, TranslatedTrueFalseChip };
